export *  from './restauracion.component';
export * from './services/restauracion.service.service';
